import React from 'react'
import { CartDetail } from '../presentation/CartDetail'

export const Cart = () => {
  return (
    <>
      <CartDetail />
    </>
  )
}
